import React from "react";

// One local marker for the toolbar, drag preview and map. No external image request.
// Explicit SVG dimensions are required by createImageBitmap in the map icon loader.
const person = '<circle cx="12" cy="4.5" r="3"/><path d="M9 9h6l2 7h-3v6h-4v-6H7z"/>';
export const STREET_VIEW_MARKER_URL = `data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="0 0 24 24"><g fill="#fbbc04" stroke="#785600" stroke-width="1.2" stroke-linejoin="round">${person}</g></svg>`
)}`;

export const StreetViewIcon = ({ size = 22 }: { size?: number }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" style={{ display: "block", flexShrink: 0 }}>
    <g fill="#fbbc04" stroke="#785600" strokeWidth="1.2" strokeLinejoin="round">
      <circle cx="12" cy="4.5" r="3" />
      <path d="M9 9h6l2 7h-3v6h-4v-6H7z" />
    </g>
  </svg>
);
